<div class="landing-page">
  <div class="page-header">
    <h1 class="page-title">Training &amp; References</h1>
    <p class="page-subtitle">Access Landpoint training modules or study and reference materials.</p>
  </div>

  <div class="options">
    <a routerLink="/training" class="option-card">
      <mat-icon class="option-icon">school</mat-icon>
      <div class="option-text">
        <span class="option-title">Training Modules</span>
        <span class="option-desc">Complete assigned training and track your progress.</span>
      </div>
      <mat-icon class="option-arrow">chevron_right</mat-icon>
    </a>

    <a [href]="studyMaterialsUrl" target="_blank" rel="noopener" class="option-card">
      <mat-icon class="option-icon">menu_book</mat-icon>
      <div class="option-text">
        <span class="option-title">Landpoint Study and Reference Materials</span>
        <span class="option-desc">Browse reference documents and study guides on SharePoint.</span>
      </div>
      <mat-icon class="option-arrow">open_in_new</mat-icon>
    </a>
  </div>
</div>
